import { Counter, Data, Filter, Pager, Query, Result } from '@/models/dynamiclist';
import ApiService from '@/services/api.service';
import { getDataProperty } from '@/services/utils';
import { State } from '@/types';

export const state: State = {
    error: undefined,
    data: JSON.parse(getDataProperty('data-data')) as Data,
    filters: JSON.parse(getDataProperty('data-filters')) as Filter[],
    pager: JSON.parse(getDataProperty('data-pager')) as Pager,
    results: JSON.parse(getDataProperty('data-results')) as Result[],
    counter: JSON.parse(getDataProperty('data-counter')) as Counter,
    query: JSON.parse(getDataProperty('data-query')) as Query,
    apiService: new ApiService(),
    activeFilterId: ''
};
